// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.authenticatedNavbarContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 100px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  position: relative;
}
.authenticatedNavbarContainer .navlink {
  display: flex;
  align-items: center;
  gap: 20px;
}
.authenticatedNavbarContainer .authLogo {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.authenticatedNavbarContainer .authlinks {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.authenticatedNavbarContainer .authlinks ul {
  display: flex;
  align-items: center;
  gap: 20px;
}
.authenticatedNavbarContainer .authlinks ul li {
  list-style: none;
  position: relative;
  cursor: pointer;
  color: #101928;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.authenticatedNavbarContainer .authlinks ul li a {
  text-decoration: none;
  color: #101928;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}
.authenticatedNavbarContainer .authlinks ul li a:hover {
  color: var(--color-blue-dark);
}
.authenticatedNavbarContainer .avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.authenticatedNavbarContainer .hamburger-menu {
  display: none;
  font-size: 24px;
  cursor: pointer;
}

/* 📱 Mobile Styles */
@media screen and (max-width: 768px) {
  .authenticatedNavbarContainer {
    padding: 10px 20px;
  }
  .authenticatedNavbarContainer .navlink {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .authenticatedNavbarContainer .authLogo {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: flex-start;
    flex-grow: 1;
  }
  .authenticatedNavbarContainer .authlinks {
    margin-left: 0;
    display: none;
  }
  .authenticatedNavbarContainer .authlinks.visible {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 100;
  }
  .authenticatedNavbarContainer .authlinks.visible ul {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .authenticatedNavbarContainer .authlinks.visible ul li a {
    font-size: 16px;
  }
  .authenticatedNavbarContainer .authlinks.visible ul .mobile-logout {
    display: block;
    font-size: 16px;
    color: red;
    cursor: pointer;
  }
  .authenticatedNavbarContainer .authlinks.visible ul .mobile-logout:hover {
    color: darkred;
  }
  .authenticatedNavbarContainer .hamburger-avatar-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .authenticatedNavbarContainer .avatar {
    display: block;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    cursor: pointer;
  }
  .authenticatedNavbarContainer .hamburger-menu {
    display: block;
    font-size: 24px;
    cursor: pointer;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/authenticated/AuthenticatedNavbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EAEA,kBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADN;AAGM;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAGQ;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADV;AAGU;EACE,6BAAA;AADZ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AANJ;AASE;EACE,aAAA;EACA,eAAA;EACA,eAAA;AAPJ;;AAWA,qBAAA;AACA;EACE;IACE,kBAAA;EARF;EAUE;IACE,aAAA;IACA,mBAAA;IACA,WAAA;EARJ;EAWE;IACE,aAAA;IACA,mBAAA;IACA,eAAA;IACA,2BAAA;IACA,YAAA;EATJ;EAYE;IACE,cAAA;IACA,aAAA;EAVJ;EAYI;IACE,aAAA;IACA,sBAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,WAAA;IACA,2BAAA;IACA,gBAAA;IACA,wCAAA;IACA,kBAAA;IAEA,YAAA;EAXN;EAaM;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EAXR;EAcU;IACE,eAAA;EAZZ;EAgBQ;IACE,cAAA;IACA,eAAA;IACA,UAAA;IACA,eAAA;EAdV;EAgBU;IACE,cAAA;EAdZ;EAqBE;IACE,aAAA;IACA,mBAAA;IACA,SAAA;EAnBJ;EAsBE;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;EApBJ;EAuBE;IACE,cAAA;IACA,eAAA;IACA,eAAA;EArBJ;AACF","sourcesContent":[".authenticatedNavbarContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 100px;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 10px;\n\n  position: relative;\n\n  .navlink {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .authLogo {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .authlinks {\n    display: flex;\n    align-items: center;\n    margin-left: 40px;\n\n    ul {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n\n      li {\n        list-style: none;\n        position: relative;\n        cursor: pointer;\n        color: #101928;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 20px;\n\n        a {\n          text-decoration: none;\n          color: #101928;\n          font-size: 14px;\n          font-weight: 600;\n          line-height: 20px;\n\n          &:hover {\n            color: var(--color-blue-dark);\n          }\n        }\n      }\n    }\n  }\n\n  .avatar {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .hamburger-menu {\n    display: none;\n    font-size: 24px;\n    cursor: pointer;\n  }\n}\n\n/* 📱 Mobile Styles */\n@media screen and (max-width: 768px) {\n  .authenticatedNavbarContainer {\n    padding: 10px 20px;\n\n    .navlink {\n      display: flex;\n      align-items: center;\n      width: 100%;\n    }\n\n    .authLogo {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      justify-content: flex-start;\n      flex-grow: 1;\n    }\n\n    .authlinks {\n      margin-left: 0;\n      display: none;\n\n      &.visible {\n        display: flex;\n        flex-direction: column;\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        width: 100%;\n        transform: translateX(-50%);\n        background: #fff;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        text-align: center;\n\n        z-index: 100;\n\n        ul {\n          flex-direction: column;\n          align-items: center;\n          gap: 20px;\n\n          li {\n            a {\n              font-size: 16px;\n            }\n          }\n\n          .mobile-logout {\n            display: block;\n            font-size: 16px;\n            color: red;\n            cursor: pointer;\n\n            &:hover {\n              color: darkred;\n            }\n          }\n        }\n      }\n    }\n\n    .hamburger-avatar-container {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n\n    .avatar {\n      display: block;\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      cursor: pointer;\n    }\n\n    .hamburger-menu {\n      display: block;\n      font-size: 24px;\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
